module.exports = __webpack_public_path__ + "img/362.bcdf7288.jpg";